// import components
import { styled, Box } from '@mui/material';

export const StyledWithFieldArrayDrawerBox = styled(Box)(() => ({
  display: 'flex',
  width: '100%',
  height: '100%',
  flexDirection: 'column',
  position: 'relative'
}));

export const StyledWithFieldArrayDrawerFooterBox = styled(Box)(({ theme }) => ({
  marginTop: 'auto',
  marginLeft: theme.spacing(5),
  marginRight: theme.spacing(5),
  bottom: 0,
  position: 'sticky'
}));
